import { render, staticRenderFns } from "./MarkdownRender.vue?vue&type=template&id=60de3826"
import script from "./MarkdownRender.vue?vue&type=script&lang=js"
export * from "./MarkdownRender.vue?vue&type=script&lang=js"
import style0 from "./MarkdownRender.vue?vue&type=style&index=0&id=60de3826&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports